import { render, staticRenderFns } from "./ScorePage.vue?vue&type=template&id=6520eb36&scoped=true"
import script from "./ScorePage.vue?vue&type=script&lang=js"
export * from "./ScorePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6520eb36",
  null
  
)

export default component.exports